import { PreIcon } from '@advanza/ui'
import type { WebinarOnboardingStatus as WebinarOnboardingStatusValue } from 'interfaces/Providers'

interface WebinarProvider {
    hubspot_contact_id?: number | null
    webinar_onboarding_attendance_status: WebinarOnboardingStatusValue | null
}

const WEBINAR_STATUS_CONFIG = {
    Subscribed: { label: 'Subscribed', color: '#f46511' },
    Attended: { label: 'Attended', color: 'rgb(12, 214, 5)' },
    'No show': { label: 'No show', color: '#f42435' },
} as const satisfies Record<WebinarOnboardingStatusValue, { label: string; color: string }>

interface Props {
    provider: WebinarProvider
}

const WebinarOnboardingStatus = ({ provider }: Props) => {
    if (!provider.hubspot_contact_id) {
        return (
            <PreIcon fontSize={18} icon="screen_share">
                <span className="text-md" style={{ color: '#9ca3af' }}>
                    No HubSpot profile
                </span>
            </PreIcon>
        )
    }
    const status = provider.webinar_onboarding_attendance_status ?? null
    const config = status ? WEBINAR_STATUS_CONFIG[status] : null
    const label = config?.label ?? 'No info'
    const color = config?.color ?? '#9ca3af'

    return (
        <PreIcon style={{ color }} fontSize={18} icon="screen_share">
            <span className="text-md" style={{ color }}>
                Webinar onboarding: {label}
            </span>
        </PreIcon>
    )
}

export default WebinarOnboardingStatus
